import React from 'react';
import { motion } from 'framer-motion';
import { FileText, MessageSquare, ShieldAlert } from 'lucide-react';
export function WhatsInside() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-198">
      <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#1A1A1A] mb-10 lg:mb-14" data-id="element-199">
        What you get inside
      </h2>

      <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-center" data-id="element-200">
        <div className="w-full lg:w-5/12" data-id="element-201">
          <div className="relative group max-w-md mx-auto lg:max-w-none" data-id="element-202">
            <div className="absolute inset-0 bg-[#1B6B3A]/5 rounded-xl transform -rotate-2 scale-105 transition-transform duration-500 group-hover:rotate-0 group-hover:scale-105" data-id="element-203" />
            <img src="https://cdn.magicpatterns.com/uploads/3Ki6N1nPFH2Me5zDJVqj5m/heylloyd-image-1770951032391.png" alt="Closing Number Lock Checklist Preview" className="relative rounded-lg shadow-xl w-full h-auto transform transition-transform duration-500 hover:-translate-y-1" data-id="element-204" />
          </div>
        </div>

        <div className="w-full lg:w-7/12" data-id="element-205">
          <p className="text-sm lg:text-base font-bold text-[#1B6B3A] mb-6 lg:mb-8 uppercase tracking-wide" data-id="element-206">
            Closing Number Lock includes:
          </p>

          <ul className="space-y-5 lg:space-y-6 mb-10 lg:mb-12" data-id="element-207">
            {[{
            text: 'Day‑7 checklist (lender + title + insurance + HOA)',
            icon: FileText
          }, {
            text: 'Day‑3 checklist (draft numbers + discrepancy catch)',
            icon: FileText
          }, {
            text: '24-hour checklist (final cash + wire safety)',
            icon: FileText
          }, {
            text: 'Moving Lines Tracker (fill-in table)',
            icon: FileText
          }, {
            text: 'Copy-paste scripts for each party (email + text)',
            icon: MessageSquare
          }, {
            text: 'Plan B options if the number increases',
            icon: ShieldAlert
          }].map((item, i) => <li key={i} className="flex items-start gap-3 lg:gap-4" data-id="element-208">
                <item.icon className="w-5 h-5 lg:w-6 lg:h-6 text-[#1B6B3A] mt-1 flex-shrink-0" data-id="element-209" />
                <span className="text-lg lg:text-xl text-[#3D3D3D]" data-id="element-210">
                  {item.text}
                </span>
              </li>)}
          </ul>

          <div className="bg-[#F0F7F2] p-6 lg:p-8 rounded-lg text-center border border-[#1B6B3A]/20" data-id="element-211">
            <p className="text-xl lg:text-2xl font-serif italic text-[#1A1A1A] mb-2" data-id="element-212">
              You're not guessing.
            </p>
            <p className="text-xl lg:text-2xl font-bold text-[#1B6B3A]" data-id="element-213">
              You're running a process.
            </p>
          </div>
        </div>
      </div>
    </motion.section>;
}